import React, { useState, useEffect } from 'react';

import Header from '../Header/Header';
import Nav from '../Nav/Nav';
import Main from '../Main/Main';
import Seo from '../Seo'

import './layout.scss';


const Layout = ({ title, children }) => {
	title = title ? title : "Home | Paystack Developer Documentation"
	const [activeNav, setActiveNav] = useState(false)
	const [activeSearch, setActiveSearch] = useState(false)

	useEffect(() => {
		activeNav ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll")
	}, [activeNav])

	return (
		<>
			<Seo title={title} />
			<div className="layout">
				<header className="layout__header">
					<Header
						isSearchActive={activeSearch}
						toggleNav={() => setActiveNav(!activeNav)}
						toggleSearch={() => setActiveSearch(!activeSearch)} />
				</header>
				<nav className={`layout__nav ${activeNav ? 'layout__nav--mobile' : ''}`}>
					<Nav isActive={activeNav} toggleNav={() => setActiveNav(!activeNav)} />
				</nav>
				<main className="layout__main">
					<Main children={children} />
				</main>
			</div>
		</>
	);
}

export default Layout;